export enum RIGHTS_INVOCATION_TYPE {
  'UNSPECIFIED' = 0,
  'GET' = 1,
  'PORTABILITY' = 2,
  'ERASURE' = 3,
}
